export const HouseIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M1.50024 12.0001L12.0002 1.50006L22.5002 12.0001L19.5002 12V23L14.7179 23V18.0001H9.35843V23L4.50024 23V12L1.50024 12.0001Z" />
      </g>
    </svg>
  );
};
